import { Typography } from '@mui/material';
import React from 'react';
import TermsContent from './TermsContentEn';
import { getLanguage } from '../../../i18n';
import TermsContentDe from './TermsContentDe';
import TermsContentEn from './TermsContentEn';

export default function TermsAndConditionsPage() {
  if (getLanguage() === 'de') {
    return <TermsContentDe />;
  }

  return <TermsContentEn />;
}
